module.exports = __webpack_public_path__ + "0af5d249/img/scraper-icon.df6ccde5.svg";